import { useTheme, Stack, Box, Paper, Button, Link, Typography, Chip, Divider, FormControlLabel, Switch, FormControl, InputLabel, Select, MenuItem, Alert } from "@mui/material";
import TitlePaper from "@components/atoms/TitlePaper/TitlePaper";
import { Link as ReactRouterLink } from "react-router-dom";
import { grey } from "@mui/material/colors";
import { ITransactionalInfoUI } from "src/types/molecules";
import Salary from "@components/atoms/Salary/Salary";
import { getCurrency } from "@utils/utils";
import ErrorAlert from "@components/atoms/ErrorAlert/ErrorAlert";
import ConfirmDialog from "../ConfirmDialog/ConfirmDialog";
import InputText from "@components/atoms/InputText/InputText";
import MoreOptions from "../MoreOptions/MoreOptions";
import { useWatch } from "react-hook-form";
import { useState, useEffect } from "react";
const TransactionalInfoUI = ({
  receiptId,
  status,
  totalPaid,
  receiptTotal,
  returnTotal,
  showError,
  closeError,
  errorMessage,
  showPayDialog,
  setShowPayDialog,
  showCloserDialog,
  setShowCloserDialog,
  showDeleteDialog,
  setShowDeleteDialog,
  showNameDialog,
  setShowNameDialog,
  register,
  control,
  pay,
  registerName,
  editName,
  close,
  pending,
  checkPending,
  payFull,
  onTotalPay,
  isLoading,
  moreOptions,
  deleteReceipt,
  isAdmin,
  employeeCode,
  setEmployeeCode,
  applicant,
  setApplicant,
  handleClosePayDialog,
  handleCloseNameDialog,
  handleCloseDeleteDialog,
  paymentMethod,
  setPaymentMethod,
  transferProof,
  setTransferProof,
  clientSummary
}: ITransactionalInfoUI) => {
  const theme = useTheme();
  const amount = useWatch({
    control,
    name: "amount"
  });
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  useEffect(() => {
    if (!transferProof) {
      setPreviewUrl(null);
      return;
    }
    const url = URL.createObjectURL(transferProof);
    setPreviewUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [transferProof]);
  const classes = {
    transacPaper: {
      position: "relative",
      width: 400,
      padding: "24px",
      height: "fit-content"
    },
    options: {
      position: "absolute",
      top: 12,
      right: 10
    },
    chipStatus: {
      fontWeight: 600,
      transform: "scale(.9)",
      marginLeft: 1
    },
    inputLabel: {
      marginBottom: 1
    }
  };
  return <>
      <Paper elevation={12} sx={classes.transacPaper}>
        <MoreOptions options={moreOptions} />
        <TitlePaper title="Resumen" subtitle="Te presentamos el estado actual del recibo junto con las opciones disponibles" />
        <Stack direction={"row"} alignItems={"center"} marginTop={1.5}>
          <Typography color={grey[500]}>Estado</Typography>{" "}
          <Chip color={status ? "success" : "secondary"} sx={classes.chipStatus} label={status ? "Abierto" : "Cerrado"} />
        </Stack>
        {clientSummary?.isOverCap && <Alert severity="warning" sx={{
        mt: 1.5
      }}>
            Cliente sobre cupo. Consumido:{" "}
            {getCurrency(clientSummary.consumedAmount)} / Cupo:{" "}
            {getCurrency(clientSummary.moneyCapAmount ?? 0)}
          </Alert>}
        <Salary label="Saldo pendiente" value={getCurrency(receiptTotal - totalPaid - returnTotal)} color={theme.palette.error.main} simple={false} weight={800} />
        <Salary label="Saldo abonado" value={getCurrency(totalPaid)} color={theme.palette.success.main} />
        <Salary label="Saldo devuelto" value={getCurrency(returnTotal)} color={theme.palette.success.main} />
        <Divider />
        <Salary label="Total a pagar" value={getCurrency(receiptTotal)} weight={800} />
        {status && <>
            <Button onClick={() => setShowPayDialog(true)} fullWidth sx={{
          marginTop: 1
        }}>
              Abonar
            </Button>
            <Link component={ReactRouterLink} to={`/recibos/${receiptId}/devoluciones`}>
              <Button fullWidth variant="outlined" sx={{
            marginTop: 1
          }}>
                Devolución
              </Button>
            </Link>
          </>}
      </Paper>
      <ConfirmDialog open={showPayDialog} cancelAction={handleClosePayDialog} confirmAction={pay} title="Registrar pago" subtitle="" message="" cancelLabel="Cancelar" confirmLabel="Abonar" contentRender={<Box marginTop={1}>
            <InputText label="Cantidad a abonar" name="amount" placeholder="Ingresa la cantidad a abonar *" register={register("amount", {
        required: true
      })} disabled={isLoading || payFull} sx={{
        mb: 2
      }} autoFocus={true} />
            <FormControlLabel control={<Switch onChange={(e: any) => onTotalPay(e.target.checked)} disabled={isLoading} />} label="Abonar total pediente" />
            <InputText label="Código de empleado" name="employeeCode" placeholder="Ingresa tu código de empleado *" register={register("employeeCode", {
        onChange: (e: React.ChangeEvent<HTMLInputElement>) => setEmployeeCode(e.target.value),
        value: employeeCode || "",
        required: true
      })} disabled={isLoading} sx={{
        mb: 2
      }} type="password" />
            <InputText label="Solicitante" name="applicant" placeholder="Ingresa el nombre del solicitante" register={register("applicant", {
        onChange: (e: React.ChangeEvent<HTMLInputElement>) => setApplicant(e.target.value),
        value: applicant || ""
      })} disabled={isLoading} sx={{
        mb: 2
      }} />
            <FormControl fullWidth sx={{
        mb: 2
      }} disabled={isLoading}>
              <InputLabel id="payment-method-label">Método de pago</InputLabel>
              <Select labelId="payment-method-label" value={paymentMethod} label="Método de pago" onChange={e => {
          setPaymentMethod(Number(e.target.value));
          setTransferProof(null);
        }} SelectDisplayProps={({
          'data-testid': 'payment-method-select'
        } as any)}>
                <MenuItem value={0}>Efectivo</MenuItem>
                <MenuItem value={1}>Transferencia</MenuItem>
              </Select>
            </FormControl>
            {paymentMethod === 1 && <Box sx={{
        mb: 2
      }}>
                <Typography variant="body2" sx={{
          mb: 1,
          fontWeight: 500
        }}>
                  Comprobante de transferencia *
                </Typography>
                <Stack direction="row" alignItems="center" spacing={1.5}>
                  <Button component="label" variant="outlined" size="small" disabled={isLoading} data-testid="transfer-proof-upload" sx={{
            flexShrink: 0,
            textTransform: "none"
          }}>
                    {transferProof ? "Cambiar imagen" : "Adjuntar imagen"}
                    <input type="file" hidden accept="image/*" disabled={isLoading} onChange={e => setTransferProof(e.target.files?.[0] ?? null)} />
                  </Button>
                  {previewUrl && <Box component="img" src={previewUrl} alt="preview" sx={{
            width: 48,
            height: 48,
            objectFit: "cover",
            borderRadius: 1,
            border: "1px solid",
            borderColor: "divider"
          }} />}
                  {transferProof && <Typography variant="caption" noWrap sx={{
            flex: 1,
            minWidth: 0
          }}>
                      {transferProof.name}
                    </Typography>}
                </Stack>
              </Box>}
          </Box>} disabled={!employeeCode.trim() || !amount || isLoading || paymentMethod === 1 && !transferProof} withEnter={true} />
      <ConfirmDialog open={showCloserDialog} cancelAction={() => {
      setShowCloserDialog(false);
      setEmployeeCode("");
    }} confirmAction={close} title="Cerrar recibo" subtitle="Ingresa tu código de empleado *" message="Por favor, Ingresa tu código de empleado * para confirmar el cierre del recibo." cancelLabel="No cerrar" confirmLabel="Sí, cerrar" contentRender={<Box sx={{
      mt: 2
    }}>
            <InputText label="Código de empleado" name="employeeCode" placeholder="Ingresa tu código de empleado *" register={register("employeeCode", {
        onChange: (e: React.ChangeEvent<HTMLInputElement>) => setEmployeeCode(e.target.value),
        value: employeeCode,
        required: true
      })} type="password" disabled={isLoading} sx={{
        mb: 2
      }} />
          </Box>} disabled={!employeeCode.trim() || isLoading} withEnter={true} />
      <ConfirmDialog open={showDeleteDialog} cancelAction={handleCloseDeleteDialog} confirmAction={deleteReceipt} title="Eliminar recibo" subtitle="Ingresa tu código de empleado *" message="Por favor, Ingresa tu código de empleado * para confirmar la eliminación del recibo." cancelLabel="No eliminar" confirmLabel="Sí, eliminar" contentRender={<Box sx={{
      mt: 2
    }}>
            <InputText label="Código de empleado" name="employeeCode" placeholder="Ingresa tu código de empleado *" register={register("employeeCode", {
        onChange: (e: React.ChangeEvent<HTMLInputElement>) => setEmployeeCode(e.target.value),
        value: employeeCode,
        required: true
      })} type="password" disabled={isLoading} sx={{
        mb: 2
      }} />
          </Box>} disabled={!employeeCode.trim() || isLoading} withEnter={true} />
      <ConfirmDialog open={showNameDialog} cancelAction={handleCloseNameDialog} confirmAction={editName} title="Editar nombre" subtitle="" message="Ingresa un nuevo nombre de factura" cancelLabel="Cancelar" confirmLabel="Editar" withEnter={true} withEscape={true} contentRender={<Box marginTop={1}>
            <InputText label="Nuevo nombre" name="name" register={registerName("name", {
        required: true
      })} disabled={isLoading} autoFocus={true} sx={{
        mb: 2
      }} />
            <InputText label="Código de empleado" name="employeeCode" placeholder="Ingresa tu código de empleado *" register={registerName("employeeCode", {
        required: true
      })} disabled={isLoading} sx={{
        mb: 2
      }} type="password" />
          </Box>} disabled={isLoading} />
      <ErrorAlert open={showError} onClose={closeError} message={errorMessage} />
    </>;
};
export default TransactionalInfoUI;